import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';

import { AuthenticationService } from './../authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  constructor(
    public http: HttpClient,
    public authenticationService: AuthenticationService
  ) {}

  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      //Authorization: this.authenticationService.currentUserValue.authdata,
    }),
  };

  public errorHandl(error: HttpErrorResponse) {
    return throwError(error.error || 'Server Error');
  }
}
